<template>
  <div>
    <PageHeaderBanner>
      <template #title>お問い合わせ</template>
    </PageHeaderBanner>
    <q-form
      ref="inquiryForm"
      autofocus
      greedy
      @submit="checkUploadFile"
      @validation-error="resetError"
    >
      <MessageChip :display="isMessageChip" level="E" :message="errMessage" />
      <div class="ciq00100-inquiry-form">
        <q-tabs
          v-model="tab"
          dense
          class="text-grey"
          active-color="primary"
          indicator-color="primary"
          align="justify"
          :breakpoint="0"
        >
          <q-tab
            :name="INQUIRY_TYPE.COMPOUND"
            label="化合物に関するお問い合わせ"
            :disable="isConfirmed"
            style="font-size: 1.1rem"
          />
          <q-tab
            :name="INQUIRY_TYPE.OTHERS"
            :disable="isConfirmed"
            label="その他のお問い合わせ"
            style="font-size: 1.1rem"
          />
        </q-tabs>
        <q-card bordered flat class="bg-grey-2 form-card">
          <q-tab-panels v-model="tab" animated class="bg-grey-2">
            <q-tab-panel :name="INQUIRY_TYPE.COMPOUND" class="q-gutter-y-md">
              <div class="row">
                <div class="col">
                  <label :class="isConfirmed ? '' : 'requier'">お問い合わせ内容</label>
                  <q-input
                    v-model="compoundInquiry"
                    :outlined="!isConfirmed"
                    dense
                    :rules="[
                      (val) => isEmpty(val) || $t('validation.required'),
                      (val) => !isHalfKana(val) || $t('validation.half_kana'),
                    ]"
                    maxlength="750"
                    counter
                    type="textarea"
                    rows="5"
                    clearable
                    :style="!isConfirmed && 'background: var(--q-white); padding:0;'"
                    :readonly="isConfirmed"
                    class="q-mb-md input-area left-input"
                  />
                </div>
              </div>
              <div class="row q-gutter-x-sm">
                <div class="col">
                  <label>必要容量</label>
                  <q-input
                    v-model="capacity"
                    :outlined="!isConfirmed"
                    dense
                    :rules="[(val) => !isHalfKana(val) || $t('validation.half_kana')]"
                    maxlength="10"
                    class="input-area"
                    clearable
                    :style="!isConfirmed && 'background: var(--q-white); padding:0;'"
                    :readonly="isConfirmed"
                    @keydown.enter.prevent
                  />
                </div>
                <div class="col">
                  <label>添付ファイル</label>
                  <q-file
                    v-model="files"
                    :outlined="!isConfirmed"
                    dense
                    clearable
                    hint="4MB以下のファイルを添付してください。"
                    :error="isMessageChip"
                    :style="!isConfirmed && 'background: var(--q-white); padding:0;'"
                    :readonly="isConfirmed"
                  >
                    <template #prepend>
                      <q-icon name="attach_file" />
                    </template>
                  </q-file>
                </div>
              </div>
              <div class="row" style="margin-top: 32px">
                <div class="col">
                  <label>お問い合わせ範囲</label>
                  <div class="q-gutter-sm">
                    <q-radio
                      v-model="inquiryRange"
                      :disable="isConfirmed"
                      val="未選択"
                      label="未選択"
                    />
                    <q-radio
                      v-model="inquiryRange"
                      :disable="isConfirmed"
                      val="市販在庫品のみ希望"
                      label="市販在庫品のみ希望"
                    />
                    <q-radio
                      v-model="inquiryRange"
                      :disable="isConfirmed"
                      val="ご注文後の合成品でも可能"
                      label="ご注文後の合成品でも可能"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <label>ご予算</label>
                  <div class="q-gutter-sm">
                    <q-radio v-model="budget" :disable="isConfirmed" val="未選択" label="未選択" />
                    <q-radio
                      v-model="budget"
                      :disable="isConfirmed"
                      val="10万円以内"
                      label="10万円以内"
                    />
                    <q-radio
                      v-model="budget"
                      :disable="isConfirmed"
                      val="50万円以内"
                      label="50万円以内"
                    />
                    <q-radio
                      v-model="budget"
                      :disable="isConfirmed"
                      val="100万円以内"
                      label="100万円以内"
                    />
                    <q-radio
                      v-model="budget"
                      :disable="isConfirmed"
                      val="100万円以上"
                      label="100万円以上"
                    />
                  </div>
                </div>
              </div>
            </q-tab-panel>
            <q-tab-panel :name="INQUIRY_TYPE.OTHERS">
              <div class="row">
                <div class="col">
                  <label :class="isConfirmed ? '' : 'requier'">お問い合わせ内容</label>
                  <q-input
                    v-model="othersInquiry"
                    :outlined="!isConfirmed"
                    dense
                    :rules="[
                      (val) => isEmpty(val) || $t('validation.required'),
                      (val) => !isHalfKana(val) || $t('validation.half_kana'),
                    ]"
                    lazy-rules
                    type="textarea"
                    rows="5"
                    maxlength="750"
                    counter
                    class="input-area left-input"
                    clearable
                    :style="
                      !isConfirmed && 'background: var(--q-white); padding:0;margin-bottom: 20px;'
                    "
                    :readonly="isConfirmed"
                  />
                </div>
              </div>
            </q-tab-panel>
          </q-tab-panels>
          <q-card-actions align="center">
            <q-btn
              v-if="!isConfirmed"
              label="お問い合わせ内容確認"
              color="primary"
              outline
              style="width: 200px; background: var(--q-white) !important"
              type="submit"
            />
            <div v-if="isConfirmed" class="q-gutter-x-xs">
              <q-btn
                color="grey-7"
                outline
                label="戻る"
                style="min-width: 120px; background: var(--q-white) !important"
                @click="isConfirmed = false"
              />
              <q-btn
                label="送信"
                icon="mdi-email-outline"
                color="primary"
                style="min-width: 120px"
                @click="checkUploadFileConfirm"
              />
            </div>
          </q-card-actions>
        </q-card>
      </div>
    </q-form>
    <AlertDialog
      :display="isDialogFlg"
      level="information"
      confirmation
      title="お問い合わせ完了"
      :text="[
        'お問い合わせありがとうございます。',
        '',
        '担当者より折り返しご連絡させていただきますので、今しばらくお待ちください。',
        '２営業日を過ぎても返答がない場合は、メールの送受信に不具合がある可能性がございますので、お手数ですがお電話にて下記までお問合せください。',
        '',
        'TEL:03-6262-6467',
      ]"
      @complete="resetForm"
    />
    <!-- アップロードダイアログ -->
    <AlertDialog
      :display="isUploadDisplayFlg"
      :level="dialogLevel"
      :confirmation="isConfFlg"
      :title="dialogTitle"
      :text="dialogText"
      @complete="isUploadDisplayFlg = false"
      @close="isUploadDisplayFlg = false"
    />
  </div>
</template>
<script setup lang="ts">
import { Loading } from 'quasar';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from '../common/axios-common';
import DetailResultStatusCode from '../common/code/DetailResultStatusCode';
import HttpResponseStatusCode from '../common/code/HttpResponseStatusCode';
import ResultStatusCode from '../common/code/ResultStatusCode';
import { isFileExist } from '../common/utils/fileUtils';
import { isEmpty, isHalfKana } from '../common/utils/validateUtils';
import PageHeaderBanner from '../components/banner/PageHeaderBanner.vue';
import MessageChip from '../components/chip/MessageChip.vue';
import AlertDialog from '../components/dialogs/AlertDialog.vue';

const router = useRouter();
const INQUIRY_TYPE = {
  COMPOUND: '1',
  OTHERS: '2',
};
// タブ
const tab = ref(INQUIRY_TYPE.COMPOUND);
// 化合物問い合わせ内容
const compoundInquiry = ref('');
// その他問い合わせ内容
const othersInquiry = ref('');
// 問い合わせ範囲
const inquiryRange = ref('未選択');
// 予算
const budget = ref('未選択');
// 必要容量
const capacity = ref('');
// アップロードファイル
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const files: any = ref('');
// 送信成功フラグ
const isConfirmed = ref(false);
// エラーメッセージ
const errMessage = ref('');
// MessageChip表示フラグ
const isMessageChip = ref(false);
// 添付ファイルパス
const inputFilePath = ref('');
// Dialog表示フラグ
const isDialogFlg = ref(false);
// Dialogタイトル
const dialogTitle = ref('');
// Dialog表示レベル
const dialogLevel = ref('');
// Dialog本文
const dialogText = ref(['']);
// 確認Dialogフラグ
const isConfFlg = ref(false);
// アップロードDialog表示フラグ
const isUploadDisplayFlg = ref(false);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const inquiryForm = ref<any>();

/**
 * 問い合わせ内容を送信
 */
const sendMail = async () => {
  errMessage.value = '';
  isMessageChip.value = false;
  const formData = new FormData();
  Loading.show();
  let path = '';
  // 化合物問い合わせタブが選択された場合
  if (tab.value === '1') {
    path = '/ciq001002/send-compound-confirm';
    formData.set('compoundInquiry', compoundInquiry.value);
    formData.set('capacity', capacity.value);
    formData.set('inputFilePath', inputFilePath.value);
    formData.set('inquiryRange', inquiryRange.value);
    formData.set('budget', budget.value);
    formData.set('file', files.value);
    // その他問い合わせタブが選択された場合
  } else {
    path = '/ciq001002/send-other-confirm';
    formData.set('otherInquiry', othersInquiry.value);
  }

  await axios
    .post(path, formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // ダイアログ表示
          isDialogFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.CAPACITY_OVER_ERROR:
            case DetailResultStatusCode.FAILED_SAVE_DATA_ERROR:
            case DetailResultStatusCode.FILE_NOT_EXIST_ERROR:
            case DetailResultStatusCode.USER_NOT_EXIST_ERROR:
            case DetailResultStatusCode.PARAMETER_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // システムエラーの場合
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * Formを初期化
 */
const resetForm = async () => {
  const reset = async () => {
    errMessage.value = '';
    isMessageChip.value = false;
    isConfirmed.value = false;
    isDialogFlg.value = false;
    compoundInquiry.value = '';
    othersInquiry.value = '';
    inquiryRange.value = '未選択';
    budget.value = '未選択';
    capacity.value = '';
    files.value = '';
  };
  await reset();
  inquiryForm.value.resetValidation();
};

/**
 * エラーチップを初期化
 */
const resetError = async () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

/**
 * 添付ファイルを保存する
 */
const saveUploadFile = async () => {
  Loading.show();
  errMessage.value = '';
  isMessageChip.value = false;

  const formData = new FormData();
  // 化合物問い合わせタブが選択された場合
  if (tab.value === '1') {
    formData.set('compoundInquiry', compoundInquiry.value);
    formData.set('capacity', capacity.value);
    formData.set('file', files.value);
    // その他問い合わせタブが選択された場合
  } else {
    formData.set('compoundInquiry', othersInquiry.value);
  }
  await axios
    .post('/ciq001001/inquiry', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // ダイアログ表示
          isConfirmed.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.CAPACITY_OVER_ERROR:
            case DetailResultStatusCode.FAILED_SAVE_DATA_ERROR:
            case DetailResultStatusCode.FILE_NOT_EXIST_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // システムエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * ファイルアップロードチェック
 */
const checkUploadFile = async () => {
  errMessage.value = '';
  isMessageChip.value = false;
  // 化合物問い合わせタブが選択された場合
  if (tab.value === '1') {
    // ファイルが添付された状態
    if (files.value) {
      isFileExist(files.value).then((value) => {
        if (value) {
          saveUploadFile();
        } else {
          dialogTitle.value = 'ファイル読み込みエラー';
          dialogLevel.value = 'error';
          if (files.value.size === 0) {
            dialogText.value = [
              '選択したファイルは内容が設定されていません。',
              'ファイルを再度選択してください。',
            ];
          } else {
            dialogText.value = [
              '更新または削除されたファイルがあるため、アップロードできませんでした。',
              'ファイルを再度選択してください。',
            ];
          }
          isConfFlg.value = true;
          isUploadDisplayFlg.value = true;
        }
      });
    }
    // 添付ファイルなしの場合、チェックを行わない
    else {
      saveUploadFile();
    }
  }
  // その他問い合わせタブが選択された場合
  else {
    isConfFlg.value = false;
    isUploadDisplayFlg.value = false;
    saveUploadFile();
  }
  window.scrollTo({ top: 0 });
};

/**
 * ファイルアップロードチェック(確認画面)
 */
const checkUploadFileConfirm = async () => {
  errMessage.value = '';
  isMessageChip.value = false;
  // 化合物問い合わせタブが選択された場合
  if (tab.value === '1') {
    // ファイルが添付された状態
    if (files.value) {
      isFileExist(files.value).then((value) => {
        if (value) {
          sendMail();
        } else {
          dialogTitle.value = 'ファイル読み込みエラー';
          dialogLevel.value = 'error';
          if (files.value.size === 0) {
            dialogText.value = [
              '選択したファイルは内容が設定されていません。',
              'ファイルを再度選択してください。',
            ];
          } else {
            dialogText.value = [
              '更新または削除されたファイルがあるため、アップロードできませんでした。',
              'ファイルを再度選択してください。',
            ];
          }
          isConfFlg.value = true;
          isUploadDisplayFlg.value = true;
        }
      });
    }
    // 添付ファイルなしの場合、チェックを行わない
    else {
      sendMail();
    }
  }
  // その他問い合わせタブが選択された場合
  else {
    isConfFlg.value = false;
    isUploadDisplayFlg.value = false;
    sendMail();
  }
  window.scrollTo({ top: 0 });
};
</script>

<style scoped>
.ciq00100-inquiry-form {
  width: 65%;
  margin: 0 auto;
}
.ciq00100-form-card {
  padding: 0.8rem 10%;
}
.ciq00100-form-card label {
  font-weight: 600;
}
</style>
<style>
.ciq00100-inquiry-form .q-textarea.q-field--dense .q-field__control {
  align-items: center;
}
</style>
